// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__XydVN","Header__logo":"Header_Header__logo__YnVa7","Header__profile":"Header_Header__profile__J8HGP"};